import { render, staticRenderFns } from "./ProductCartoon.vue?vue&type=template&id=555864cc&scoped=true"
import script from "./ProductCartoon.vue?vue&type=script&lang=js"
export * from "./ProductCartoon.vue?vue&type=script&lang=js"
import style0 from "./ProductCartoon.vue?vue&type=style&index=0&id=555864cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555864cc",
  null
  
)

export default component.exports